export const GATEWAY_STATUS = {
  ONLINE: 'online',
  WARNING: 'warning',
  ERROR: 'error',
  OFFLINE: 'offline',
} as const
